import { createAction } from '@ngrx/store';

export const showLoader = createAction('[HttpRequest | Init] Loading - Start');

export const hideLoader = createAction('[HttpRequest | End] Loading - Stop');
